import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DashboardGpsMap } from "../DashboardGpsMap";

const IMG = (v) => {
  const c = (v.category || "").toLowerCase(), s = Number(v.seats || 4);
  if (/minibus/.test(c) || (s > 8 && s <= 19)) return "/fleet/minibus.jpg";
  if (/bus/.test(c) || s > 19) return "/fleet/bus.jpg";
  if (/van/.test(c) || s > 4) return "/fleet/van.jpg";
  return "/fleet/berlina.jpg";
};

export function LiveFleet({ vehicles, inService, driverOf }) {
  const nav = useNavigate();
  return (
    <section className="mb-card p-4 md:p-5 min-w-0 flex flex-col" data-testid="mb-live-fleet">
      <header className="flex items-center justify-between mb-3">
        <h2 className="font-display text-xl text-white">Veicoli in tempo reale</h2>
        <button type="button" onClick={() => nav("/gps-live")} className="h-8 px-3 rounded-full border border-[#D4A72C]/50 text-[12px] text-[#F1D27A] inline-flex items-center gap-1.5 hover:bg-[#D4A72C]/10" data-testid="mb-live-map-btn">Vedi mappa <ArrowRight size={13} /></button>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr] gap-3 flex-1 min-h-0">
        <div className="min-w-0 mb-map"><DashboardGpsMap title="" /></div>
        <div className="space-y-2 max-h-[420px] overflow-y-auto" data-testid="mb-fleet-list">
          {vehicles.map(v => {
            const on = inService.has(v.id);
            const st = on ? ["In servizio", "text-sky-300"] : v.status === "disponibile" ? ["Disponibile", "text-emerald-400"] : [v.status ? v.status.charAt(0).toUpperCase() + v.status.slice(1) : "Stato non indicato", "text-[#E9C46A]"];
            return (
              <button key={v.id} type="button" onClick={() => nav("/flotta")} data-testid={`mb-fleet-${v.id}`} className="w-full flex items-center gap-3 p-2 rounded-xl border border-white/[0.07] bg-black/30 hover:border-[#D4A72C]/40 text-left">
                <img src={IMG(v)} alt="" className="w-16 h-11 object-cover rounded-md shrink-0" />
                <span className="min-w-0 leading-tight">
                  <span className="block text-[11.5px] text-white font-semibold uppercase truncate">{v.brand} {v.model}</span>
                  <span className="block text-[11px] text-slate-400 truncate">{driverOf(v) || "Nessun autista associato"} · {v.plate}</span>
                  <span className={`block text-[11px] ${st[1]}`}>{st[0]}</span>
                </span>
              </button>
            );
          })}
          {!vehicles.length && <div className="text-sm text-slate-500 text-center py-8">Nessun veicolo in flotta</div>}
        </div>
      </div>
    </section>
  );
}
